import { call, put, takeEvery } from "redux-saga/effects";

// Calender Redux States
import {
  ADD_NEW_REUSEABLE,
  DELETE_REUSEABLE,
  EXPORT_REUSEABLE_EXCEL,
  GET_REUSEABLE_DETAILS,
  GET_REUSEABLE_LIST,
  UPDATE_REUSEABLE
} from "./actionTypes";

import {
  addReuseableSettingFail,
  addReuseableSettingSuccess,
  deleteReuseableFail,
  deleteReuseableSuccess,
  exportReuseableExcelFail,
  exportReuseableExcelSuccess,
  getReuseableDetailsFail,
  getReuseableDetailsSuccess,
  getReuseableListingFail,
  getReuseableListingSuccess,
  updateReuseableFail,
  updateReuseableSuccess
} from "./actions";

import {
  reuseableAddApi,
  reuseableDeleteApi,
  reuseableExportApi,
  reuseableDetailsApi,
  reuseableListingApi,
  reuseableUpdateApi
} from "./settingApi.js";

function* fetchReuseableSetting(payload) {
  try {
    const response = yield call(reuseableListingApi, payload)
    yield put(getReuseableListingSuccess(response))
  } catch (error) {
    yield put(getReuseableListingFail(error))
  }
}

function* fetchReuseableSettingDetails({ payload}) {
  try {
    const response = yield call(reuseableDetailsApi, payload)
    yield put(getReuseableDetailsSuccess(response))
  } catch (error) {
    yield put(getReuseableDetailsFail(error))
  }
}

function* onaddNewReuseable({ payload}) {
  try {
    const response = yield call(reuseableAddApi, payload)
    yield put(addReuseableSettingSuccess(response))
  } catch (error) {
    yield put(addReuseableSettingFail(error))
  }
}

function* onupdateReuseable({ payload }) {
  try {
    const response = yield call(reuseableUpdateApi, payload)
    yield put(updateReuseableSuccess(response))
  } catch (error) {
    yield put(updateReuseableFail(error))
  }
}

function* onDelReuseableSetting({ payload }) {
  try {
    const response = yield call(reuseableDeleteApi, payload)
    yield put(deleteReuseableSuccess(response))
  } catch (error) {
    yield put(deleteReuseableFail(error))
  }
}

function* onexportReuseableExcel({ payload }) {
  try {
    const response = yield call(reuseableExportApi, payload)
    yield put(exportReuseableExcelSuccess(response))
  } catch (error) {
    yield put(exportReuseableExcelFail(error))
  }
}

function* ReuseableSettingSaga() {
  yield takeEvery(GET_REUSEABLE_LIST, fetchReuseableSetting)
  yield takeEvery(GET_REUSEABLE_DETAILS, fetchReuseableSettingDetails)
  yield takeEvery(ADD_NEW_REUSEABLE, onaddNewReuseable)
  yield takeEvery(UPDATE_REUSEABLE, onupdateReuseable)
  yield takeEvery(DELETE_REUSEABLE, onDelReuseableSetting)
  // yield takeEvery(UPDATE_PW_REUSEABLE_SETTING, onUpdatePWReuseableSetting)
  yield takeEvery(EXPORT_REUSEABLE_EXCEL, onexportReuseableExcel)

}

export default ReuseableSettingSaga
